import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b118e876")

_pushScopeId("data-v-b118e876")
const _hoisted_1 = { class: "navigation_main" }
const _hoisted_2 = { class: "head_top_listCont" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "iconfont icon-zhankai" }, null, -1)
const _hoisted_4 = { class: "navigation_option" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("ul", {
        class: ["head_top_list", {"mt0": !_ctx.state.hasWarn}],
        id: "checkItemList"
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.tabList, (item) => {
          return (_openBlock(), _createBlock("li", {
            onClick: ($event: any) => (_ctx.clickTab(item.code, $event)),
            key: item.code,
            id: `${item.code}1`,
            class: ["head_top_listItem", {'head_top_listItem_active': _ctx.state.currentName === item.code}]
          }, _toDisplayString(item.name), 11, ["onClick", "id"]))
        }), 128))
      ], 2)
    ]),
    _createVNode("div", {
      class: "navigation_switch",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeShowOptions && _ctx.changeShowOptions(...args)))
    }, [
      _hoisted_3
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("ul", {
        class: ["navigation_option_list", {"mt0": !_ctx.state.hasWarn}]
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.tabList, (item) => {
          return (_openBlock(), _createBlock("li", {
            onClick: ($event: any) => (_ctx.clickOptions(item.code, $event)),
            key: item.code,
            id: `${item.code}1`,
            class: ["navigation_option_listItem", {'navigation_option_listItem_active': _ctx.state.currentName === item.code}]
          }, _toDisplayString(item.name), 11, ["onClick", "id"]))
        }), 128))
      ], 2)
    ], 512), [
      [_vShow, _ctx.state.showOptions]
    ])
  ], 512)), [
    [_vShow, _ctx.state.isShowTopNav]
  ])
})